<template>
  <div class="jobs-body-inspector-row">
    <div class="jobs-body-inspector">
      <div class="jobs-body-inspector__details">
        <a class="export-incompletes" v-if="['cancelled'].includes(details.state) && details.devices.length" @click="() => { exportIncompletes(); }"><small>Export Incomplete Device IDs</small></a>
        <div class="jobs-body-inspector__job-item jobs-body__bounce">
          <!-- Summary -->
          <div style="display: flex; gap: .75em; justify-content: space-between; align-items: center;">
            <b-button :id="`jobDetails-${details.sensorJobRequestId}`" style="width: 24px; height: 24px; border-width: 0px;" class="btn-sm btn-success btn-margin jobs-body__tab-item--radio-button">
              <font-awesome-icon :style="{ color: '#1dd8f6' }" v-if="!['completed', 'errored',  'cancelled', 'scheduled'].includes(details.state)" icon="cloud"  />
              <font-awesome-icon :style="{ color: '#eed202 ' }" v-if="['errored', 'cancelled'].includes(details.state)" icon="exclamation-triangle"  />
              <font-awesome-icon :style="{ color: '#66be6d' }" v-if="['completed'].includes(details.state)" icon="check"  />
              <font-awesome-icon :style="{ color: '#66be6d' }" v-if="['scheduled'].includes(details.state)" icon="calendar"  />
            </b-button>
            <div style="font-weight: 400;display: flex; justify-content: flex-start; flex: 1 1 100%; flex-direction: row;">
              <div style="font-weight: 400;display: inline-flex; justify-content: flex-start; flex: 1 1 100%; flex-direction: column;">
                <b>
                  {{ details.isSilent ? 'Prerequisite' : 'Job' }}: {{ details.displayName }} ({{details.sensorJobRequestId}})           
                </b> 
                <div style="display: flex; flex-direction: row; gap: .75em; margin-top: .25em;">
                  <div v-if="Array.isArray(details.devices)" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Models</strong></small>
                    <i style="font-size: 10px;">{{ Array.from(new Set(details.devices.map((device) => `${device.model} ${device.subModel}`))).join(', ')}}</i>
                  </div>
                  <div v-if="details.state" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Current State</strong></small>
                    <i style="font-size: 10px;">{{ details.state.toUpperCase() === 'ERRORED' ? 'COMPLETED (at least one failure)': details.state.toUpperCase()}}</i>
                  </div>
                  <div v-if="details.template" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Template</strong></small>
                    <i style="font-size: 10px;">{{ details.template }}</i>
                  </div>
                  <!-- <div v-if="details.scheduledTimeUTC && state === 'scheduled'" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Scheduled At</strong></small>
                    <i style="font-size: 10px;">
                      {{ moment(details.scheduledTimeUTC).format("dddd, MMMM Do YYYY, h:mm:ss a") }}
                    </i>
                  </div> -->
                  <div v-if="details.startedAt" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Started At</strong></small>
                    <i style="font-size: 10px;">
                      {{ moment(details.startedAt).format("dddd, MMMM Do YYYY, h:mm:ss a") }}
                    </i>
                  </div>
                  <div v-if="details.cancelledAt" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Cancelled At</strong></small>
                    <i style="font-size: 10px;">
                      {{ moment(details.cancelledAt).format("dddd, MMMM Do YYYY, h:mm:ss a") }}
                    </i>
                  </div>
                  <div v-if="details.completedAt" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Completed At</strong></small>
                    <i style="font-size: 10px;">
                      {{ moment(details.completedAt).format("dddd, MMMM Do YYYY, h:mm:ss a") }}
                    </i>
                  </div>
                  <div v-if="details.expiration" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Expires</strong></small>
                    <i style="font-size: 10px;">
                      {{ moment(details.expiration).format("dddd, MMMM Do YYYY, h:mm:ss a") }}
                    </i>
                  </div>
                  <div v-if="Array.isArray(details.devices) && Array.isArray(details.tasks) && details.devices.reduce((sum, item) => sum + (item.tasksComplete ? item.tasksComplete : 0), 0) !== 0" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Tasks Complete</strong></small>
                    <i style="font-size: 10px;">
                      {{ details.devices.reduce((sum, item) => sum + (item.tasksComplete ? Array.isArray(item.tasksComplete) ? item.tasksComplete.length : item.tasksComplete : 0), 0) }} / {{ details.devices.length * details.tasks.length }} tasks complete.
                    </i>
                  </div>
                  <div v-if="Array.isArray(details.devices) && Array.isArray(details.tasks) && details.devices.filter((device) => device.isCompleted).length !== 0" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Devices Complete</strong></small>
                    <i style="font-size: 10px;">
                      {{ details.devices.filter((device) => device.isCompleted).length }} devices complete.
                    </i>
                  </div>
                  <div v-if="Array.isArray(details.devices) && Array.isArray(details.tasks) && details.devices.filter((device) => device.errorDetected).length !== 0" style="display: flex; flex-direction: column; gap: .25em;">
                    <small><strong>Devices Reporting Errors</strong></small>
                    <i style="font-size: 10px;">
                      {{ new Set(details.devices.filter((device) => device.errorDetected).map(item => item.deviceId)).size }} devices reporting errors.
                    </i>
                  </div>
                </div>
              </div>
            </div>

            <b-popover :target="`jobDetails-${details.sensorJobRequestId}`" id="jobDetails" 
              triggers="hover" placement="top"
              v-bind:title="'Details'">
              <p>
                <strong>Created: </strong> 
                <span style="font-weight: 500;">
                  {{`Created by ${details.user.id} on ${moment(details.createdAt).format("dddd, MMMM Do YYYY, h:mm:ss a")}`}}
                </span>
              </p>
              <p>
                <strong>Scheduled Crontime: </strong> 
                <span style="font-weight: 500;">
                  {{details.scheduledTime}}
                </span>
              </p>
              <p>
                <strong>State: </strong>
                <font-awesome-icon :style="{ color: '#1dd8f6' }" v-if="!['completed', 'errored',  'cancelled', 'scheduled'].includes(details.state)" icon="cloud"  />
                <font-awesome-icon :style="{ color: '#eed202 ' }" v-if="['errored', 'cancelled'].includes(details.state)" icon="exclamation-triangle"  />
                <font-awesome-icon :style="{ color: '#66be6d' }" v-if="['completed'].includes(details.state)" icon="check"  />
                <font-awesome-icon :style="{ color: '#66be6d' }" v-if="['scheduled'].includes(details.state)" icon="calendar"  />
                {{ details.state.toUpperCase() === 'ERRORED' ? 'COMPLETED (at least one failure)': details.state.toUpperCase()}}
              </p>
              <p v-if="details.reason">
                <strong>Reason: </strong>
                <font-awesome-icon :style="{ color: '#1dd8f6' }" v-if="!['completed', 'errored',  'cancelled', 'scheduled'].includes(details.state)" icon="cloud"  />
                <font-awesome-icon :style="{ color: '#eed202 ' }" v-if="['errored', 'cancelled'].includes(details.state)" icon="exclamation-triangle"  />
                <font-awesome-icon :style="{ color: '#66be6d' }" v-if="['completed'].includes(details.state)" icon="check"  />
                <font-awesome-icon :style="{ color: '#66be6d' }" v-if="['scheduled'].includes(details.state)" icon="calendar"  />
                {{ details.reason.toUpperCase() }}
              </p>
              <p v-if="details && details.deviceFilter">
                <strong>Devices Requested: </strong>
                {{details.deviceFilter}}
              </p>
              <p v-if="details && Array.isArray(details.devices) && details.devices.length">
                <strong>Devices Impacted: </strong>
                {{details.devices.length}}
              </p>
            </b-popover>
            <div style="flex: 1; display: flex; gap: .75em; justify-content: flex-end;">
            </div>
            <div style="display: flex; justify-content: flex-end;">
              <!-- // Refresh -->
            </div>
          </div>

          <p v-if="job && job.tasks">
            <strong>
              <a v-b-toggle="`collapse-tasks-${details.sensorJobRequestId}`" href="javascript:void(0)" style="color: #484848; text-decoration: none;">
                <div style="display: flex; gap: 15px; justify-content: flex-start; align-items: center; font-size: 14px;">
                  <font-awesome-icon class="job-details-icon-expand" :style="{ width: 'auto', height: '15px' }" icon="expand" />
                  <font-awesome-icon class="job-details-icon-collapse" :style="{ width: 'auto', height: '15px' }" icon="compress" />
                  Tasks <small>({{ job.tasks.length }})</small>
                </div>
              </a>
            </strong>
          </p>
          <b-collapse v-if="job && job.tasks" :id="`collapse-tasks-${details.sensorJobRequestId}`" style="font-size: 14px;">
            <b-card>
              <div class="jobs-body-inspector__job-item" v-for="(item, index) in job.tasks" :value="index" :key="index">
                <p>
                  <strong >Type:</strong> <span style="font-weight: 500;">{{item.type}}</span>
                </p>
                <p>
                  <strong >Payload:</strong> <span style="font-weight: 500;">{{item.payload}}</span>
                </p>
              </div>
            </b-card>
          </b-collapse>

          <!-- Tree -->
          <p v-if="job && Array.isArray(job.locations) && details && Array.isArray(details.tasks)">
            <strong>
              <a v-b-toggle="`collapse-details-${details.sensorJobRequestId}`" href="javascript:void(0)" style="color: #484848; text-decoration: none;">
                <div style="display: flex; gap: 15px; justify-content: flex-start; align-items: center; font-size: 14px;">
                  <font-awesome-icon class="job-details-icon-expand" :style="{ width: 'auto', height: '15px' }" icon="expand" />
                  <font-awesome-icon class="job-details-icon-collapse" :style="{ width: 'auto', height: '15px' }" icon="compress" />
                  Details 
                </div>
              </a>
            </strong>
          </p>
          <b-collapse v-if="job && Array.isArray(job.locations) && details && Array.isArray(details.tasks)" :id="`collapse-details-${details.sensorJobRequestId}`">
            <b-card>
              <div v-if="Array.isArray(details.tasks) && Array.isArray(details.devices)" class="jobs-body-inspector__job-item">
                <JobTree :recyclingJobList="recyclingJobList" :recycling="recycling" :tasks="details.tasks" :devices="details.devices" :tree="job.locations.map((item) => {
                  item.id = item.locationId;
                  return item;
                })" />
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JobTree from "./JobTree.vue";
import { fetchWithBackoff } from "../../shared/utils/fetchWithBackoff";
const moment = require("moment");

Vue.use(VueToast);
Vue.use(Loading);

export default {
  name: "Job",
  components: {
    JobTree
  },
  data() {
    return {
      jobsManager: this.$auth && this.$auth.user && this.$auth.user.hasOwnProperty('https://care.ai/permissions') && this.$auth.user['https://care.ai/permissions'].find((role) => role === "jobs:mgr") ? true : false,
      console: console,
      totalIncompleteTasks: 0,
      totalCompleteTasks: 0,
      errorMessage: '',
      message: '',
      devices: [],
      job: null,
      locations: [],
      recycling: false,
      recyclingTime: null,
      recyclingJobList: [],
      moment: moment,
    };
  },
  mounted() {
    // Initial
    this.fetchData();

    // Start Poll
    window.jobInterval = setInterval(this.fetchData, 20000) // Fetches data by the 20 second interval

    // Used as ON DESTROY - tear down polling when navigating away
    this.$router.afterEach(() => {
      try {
        clearInterval(window.jobInterval);
      } catch (e) { console.log(e); }
    });
  },
  beforeUnmount() {
    try {
      clearInterval(window.jobInterval);
    } catch { null }
  },
  methods: {
    reschedule() {
      this.recycling = !this.recycling;
    },
    
    padZero(number) {
        return number < 10 ? '0' + number : number;
    },
    
    getLocalTimestampISOString(baseTime = new Date(), minutesDiff) {
        const futureDate = new Date(baseTime.getTime() + minutesDiff * 60000);

        const year = futureDate.getFullYear();
        const month = this.padZero(futureDate.getMonth() + 1);
        const day = this.padZero(futureDate.getDate());
        const hours = this.padZero(futureDate.getHours());
        const minutes = this.padZero(futureDate.getMinutes());

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    },

    exportIncompletes() {
      if (!Array.isArray(this.devices) || this.devices.length === 0) {
        return;
      }
      const isNotComplete = this.devices.filter((device) => !device.isCompleted);
      this.console.log(isNotComplete);
      if (Array.isArray(isNotComplete) && isNotComplete.length) {
        let deviceIdsCsv = 'Device IDs\n';
        const { tenant, sensorJobRequestId } = JSON.parse(JSON.stringify(this.details));
        deviceIdsCsv += isNotComplete.map((device) => device.deviceId).join('\n');
        // Offer Save File
        const blob = new Blob([deviceIdsCsv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', `${tenant}_${sensorJobRequestId}_incomplete_devices.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return;
      }
    },

    fetchData() {
      this.fetchJobDetails().then(() => {
        this.totalIncompleteTasks = 0;
        this.totalCompleteTasks = 0;
        this.devices.forEach((device) => {
          this.gatherDeviceTasks(device.deviceId);
        });
        this.$forceUpdate();
      });
    },

    formatArrayWithLimit(arr, limit = 5) {
      if (!Array.isArray(arr) || arr.length === 0) {
        return '';
      }

      const displayedItems = arr.slice(0, limit);
      const remainingCount = arr.length - limit;

      const formattedString = displayedItems.join(', ');
      
      if (remainingCount > 0) {
        return `${formattedString} and ${remainingCount} more selected`;
      }
      
      return formattedString;
    },

    isUUID(uuid) {
      let s = "" + uuid;
      s = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
      if (s === null) {
        return false;
      }
      return true;
    },

    async fetchJobDetails() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
      const { tenant, sensorJobRequestId } = JSON.parse(JSON.stringify(this.details));
      if (tenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        if (!id_token) return;

        // eslint-disable-next-line no-undef
        var request = new Request(config.OPERATIONS_SERVICE + `/tenants/${tenant}/sensors/jobs/${sensorJobRequestId}?expandDetails=true`, {
          method: 'GET',
          mode: 'cors',
          cache: 'default',
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: 'Bearer ' + id_token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        });

        try {
          const data = await fetchWithBackoff(request);
          if (!data) return;

          const res = JSON.parse(JSON.stringify(data));
          if (res.devices.length) {
            const validIDs = [];

            if (res.devices.length) {
              res.devices.forEach((device) => {
                validIDs.push(device.deviceId);
                const exists = this.devices.find((existing) => device.deviceId === existing.deviceId);
                if (exists) {
                  Object.keys(device).forEach((key) => {
                    exists[key] = device[key];
                  })
                } else this.devices.push(device);

                for (let i = 0; i < this.devices.length; i++) {
                  if (!validIDs.includes(this.devices[i].deviceId)) {
                    this.devices.splice(i, 1);
                    i--; 
                  }
                }
              });
            } else if (this.devices.length > 0) {
              this.devices = [];
              this.$forceUpdate();
            }

            if (this.job) {
              Object.keys(res).forEach((key) => {
                this.job[key] = res[key];
              })
            } else this.job = res;
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to get jobs due to an error.', type: 'error'});
        }
      }
    },

    gatherDeviceTasks(deviceId) {
      if (this.job && this.job.details && this.job.details[deviceId]) {
        const deviceSpecificTasks = this.job.details[deviceId];
        if (Array.isArray(deviceSpecificTasks)) {
          const deviceRef = this.devices.find((device) => device.deviceId === deviceId);
          if (deviceRef) {
            if (Array.isArray(deviceRef.tasks)) {
              deviceRef.tasks = deviceRef.tasks.filter((existingTask) => deviceSpecificTasks.find((newTask) => newTask.taskId === existingTask.taskId));
              deviceSpecificTasks.forEach((spec) => {
                const exists = deviceRef.tasks.find((existing) => spec._id === existing._id);
                if (exists) {
                  Object.keys(spec).forEach((key) => {
                    exists[key] = spec[key];
                  })
                } else deviceRef.tasks.push(spec);
              })
            } else deviceRef.tasks = deviceSpecificTasks;
            deviceRef.tasks = deviceRef.tasks.sort((a, b) => a.taskId - b.taskId);
            deviceRef.incompleteTasks = deviceSpecificTasks.filter((task) => !task.completedAt);
            deviceRef.completeTasks = deviceSpecificTasks.filter((task) => task.completedAt);
      
            // Generate usable references for this data
            this.totalIncompleteTasks += deviceRef.incompleteTasks.length;
            this.totalCompleteTasks += deviceRef.completeTasks.length;
          }
        }
      } 
    },

    async submitJob() {
      if (this.recyclingJobList.length && Array.isArray(this.templates)) {
        if (this.details.templateId) {
          const details = JSON.parse(JSON.stringify(this.details));
          const result = confirm("Are you sure you want to submit this job for the selected devices? You will leave this page.");
          if (result && this.templates.find((template) => details.templateId === template._id)) {
            const payload = {
              devices: this.recyclingJobList,
              template: details.templateId,
            }
            this.$emit('recycle', payload);
          }
        } else alert('Job does not have a templateId.');
      } else alert('You have no devices selected.');
    },
  },
  props: ["details", "templates"],
};
</script>

<style lang="scss" scoped>
  .jobs-body {
    display: flex;
    width: 100%;
    height: 100%;
    padding: 0 1em;
    font-size: 14px;

    .collapsed {
      .job-details-icon-expand {
        display: inline-block;
      }
      .job-details-icon-collapse {
        display: none;
      }
    }

    .not-collapsed {
      .job-details-icon-expand {
        display: none;
      }
      .job-details-icon-collapse {
        display: inline-block;
      }
    }

    .card-body {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }

    p {
      margin: 0;
    }

    .nav {
      display: flex; 
      gap: .33em;

      .nav-item {
        margin: 0;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        padding-bottom: .3em;
        background: transparent;
        border-top: 1px solid #f3f3f3;
        border-right: 1px solid #f3f3f3;
        border-left: 1px solid #f3f3f3;
        transition: all ease-in-out 300ms;

        a.nav-link {
          padding: 0.25rem 1rem;
          color: #484848;
          font-size: 14px;
          font-weight: 400;
        }

        &:hover {
          background: #f3f3f3;
        }
      }

      .active {
        background: #00b5da;

        a.nav-link {
          color: white;
        }

        &:hover {
          background: #1dd8f6;
        }
      }
    }

    &__inner {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
      padding: .75em;
      border-bottom-left-radius: .25em;
      border-bottom-right-radius: .25em;
      border: 1px solid #f1f1f1;
    }

    &__tab-container {
      display: flex;
      flex-wrap: wrap;
      padding: 0.75em 0;
      position: sticky;
      top: 0;
      background: white;
      width: 100%;
      z-index: 1;
    }

    &__tab-item {
      transition: color 150ms;
      color: #484848;
      padding:0 0.75em 0.75em 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      &.dropdown{
        padding: 0;
      }

      &--schedule-button {
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: transparent;
        color: #28a745; 
        display: flex; flex-wrap: nowrap; align-items: center; gap: 15px;
        border: none;
        outline:none;
        border: 1px solid #66be6d;
        transition: all ease-in-out 300ms;

        &:hover {
          color: white;
          background: #28a745; 
        }
      }

      &--cancel-button {
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: transparent;
        color: #ebd15c; 
        display: flex; flex-wrap: nowrap; align-items: center; gap: 15px;
        border: none;
        outline:none;
        border: 1px solid #ebd15c;
        transition: all ease-in-out 300ms;

        &:hover {
          color: white;
          background: #ebd15c; 
        }
      }

      &--radio-button {
        justify-content: center;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: transparent;
        color: #2e2e2e; 
        display: inline-flex; flex-wrap: nowrap; align-items: center; gap: 15px;
        border: none;
        outline:none;
        border: 1px solid transparent;
        transition: all ease-in-out 300ms;

        &:hover {
          background: #d7d7d7; 
        }
      }

      &--button {
        color: rgb(248, 248, 248);
        border: none;
        outline:none;

        &:hover {
          color: white;
        }
      }

      &--refresh-button {
        width: 20px; 
        height: 20px; 
        filter: brightness(0) saturate(100%) invert(36%) sepia(18%) saturate(0%) hue-rotate(179deg) brightness(82%) contrast(93%);
        transition: all ease-in-out 300ms;

        &:hover {
          filter: brightness(0) saturate(100%) invert(49%) sepia(7%) saturate(6%) hue-rotate(337deg) brightness(86%) contrast(88%);
        }
      }

      label {
        margin-bottom: 0;
        margin-left: .25em;
      }

      &--selected {
        color: #1dd8f6;
      }

      &:hover {
        color: #1dd8f6;
      }
    }
  }

  .jobs-body-inspector-row {
    display: flex;
    flex: 100%;
    gap: .75em;
  }

  .jobs-body-inspector {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    flex: 50%;
    padding: .75em;
    border-radius: .25em;
    border: 1px solid #f1f1f1;

    &__header {
      width: 100%;
    }

    &__details {
      position: relative;
      display: flex;
      justify-content: center;
      font-size: 14px;
      color: #484848;
      flex: 1;
      flex-direction: column;
      gap: .75em;
      overflow: visible;

      a.export-incompletes {
        position: absolute;
        top: 0.75em;
        right: 0.75em;
        font-size: 12px;
        cursor: pointer;
        color: #1dd8f6;
        text-decoration: underline;
        transition: all ease-in-out 300ms;
        z-index: 5;
      }

      .jobs-body-inspector__job-item.right{
        margin-right: 0.75em;
      }
    }

    &__job-item {
      display: flex;
      flex-direction: column;
      padding: .75em;
      gap: .75em;
      border-radius: .25em;
      border: 1px solid rgba(0, 0, 0, .05);
      background: rgba(0, 0, 0, .03);

      p {
        display: flex;
        margin-left: 10px;
        strong {
          display: inline-block;
          min-width: 90px;
          text-align: right;
          padding-right: .75em;
        }
      }

      span {
        font-size: 14px;
      }
    }

    .jobs-body__bounce {
      opacity: 0;
      transform: scale(1);
      animation: fadeIn 800ms forwards;
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
</style>